var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "mask-closable": false,
        visible: _vm.showModal,
        width: "488",
        title: _vm.modalheader,
      },
      on: {
        "update:visible": function ($event) {
          _vm.showModal = $event
        },
      },
    },
    [
      _c(
        "p",
        { staticClass: "modalHead", attrs: { slot: "header" }, slot: "header" },
        [_c("span", [_vm._v(_vm._s(_vm.modalheader))])]
      ),
      _c("div", { staticClass: "modalContent" }, [
        _c("p", [
          _vm._v(
            " " + _vm._s(_vm.$t("cashAccount.remittance.modalTipsWarn1")) + " "
          ),
          _c(
            "i",
            { staticStyle: { color: "#1FA0E8", "font-style": "normal" } },
            [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("cashAccount.remittance.modalTipsWarn2")) +
                  " "
              ),
            ]
          ),
          _vm._v(" " + _vm._s(_vm.$t("cashAccount.remittance.modalTipsWarn3"))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "textright", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "pp-button",
            {
              staticClass: "pp-btn pp-btn-ghost pp-btn-spec",
              on: { click: _vm.toService },
            },
            [_vm._v(_vm._s(_vm.modalbtn))]
          ),
          _c(
            "pp-button",
            {
              staticClass: "pp-btn pp-btn-primary pp-btn-spec",
              on: { click: _vm.leftBtnFun },
            },
            [_vm._v(_vm._s(_vm.$t("cashAccount.remittance.confirm")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }